import { useTranslation } from "react-i18next";

import {
  CAROUSEL_ASSETS,
  FooterAssetItem,
  FooterAssetKey,
  FooterDisplayMode,
  GRID_ASSETS,
} from "@/config/FooterAssetsCatalog";

const CAROUSEL_LOOP_COPIES = 2;

type InputProps = {
  contextualInformationVisible?: boolean;
  /** @deprecated use `displayMode="grid" | "none"` instead. */
  footerAppsWebsitesIconsVisible?: boolean;
  displayMode?: FooterDisplayMode;
  excludeAssetKey?: FooterAssetKey;
  contextualInformationLink?: boolean;
  message?: string;
};

export default function Footer({
  footerAppsWebsitesIconsVisible = false,
  displayMode,
  excludeAssetKey,
  message = "",
  contextualInformationLink = true,
  ...props
}: InputProps) {
  const { t } = useTranslation();

  const resolvedDisplayMode: FooterDisplayMode =
    displayMode ?? (footerAppsWebsitesIconsVisible ? "grid" : "none");

  const defaultMessageKey =
    resolvedDisplayMode === "carousel"
      ? "common.carousel_footer_message"
      : "common.mobile_footer_message";
  const messageToShow = message === "" ? t(defaultMessageKey) : message;

  const iconItem = (item: FooterAssetItem) => {
    return (
      <div className="icon-item flex flex-col items-center text-center w-1/3" key={item.key}>
        <img className="w-22 h-22" src={item.squareIcon} alt={item.altText} />
        <p className="w-28 text-center p-0 m-0 h-24 content-center text-[10px] font-semibold text-[var(--on-surface-variant)]">{t(item.labelI18nKey)}</p>
      </div>
    );
  };

  const carouselIconItem = (item: FooterAssetItem, copyIndex: number) => {
    return (
      <div className="icon-item flex flex-col items-center text-center px-4 mr-[3px] flex-shrink-0 self-center" key={`${item.key}-${copyIndex}`}>
        <img src={item.icon} alt={item.altText} />
      </div>
    );
  };

  const carouselAssets = CAROUSEL_ASSETS.filter((item) => item.key !== excludeAssetKey);

  return (
    <div className="flex justify-center min-w-0 w-full overflow-x-hidden mt-16">
      <div aria-hidden className="min-w-0 w-full overflow-x-hidden">
        {props.contextualInformationVisible && (
          <div className="w-94 text-sm text-center font-bold m-auto text-[var(--on-surface-variant)]">{messageToShow}</div>
        )}
        {resolvedDisplayMode === "grid" && (
          <div className="icon-container w-full flex justify-center">
            <div className="icon-inner-container flex flex-wrap justify-center gap-y-10 mt-16 ">
              {GRID_ASSETS.map(iconItem)}
            </div>
          </div>
        )}
        {resolvedDisplayMode === "carousel" && (
          <div className="icon-container w-full min-w-0 flex justify-center relative">
            <div className="w-full max-w-[26rem] min-w-0 overflow-hidden mt-8 pb-2">
              <div className="icon-inner-container flex w-max flex-nowrap animate-marquee motion-reduce:animate-none">
                {Array.from({ length: CAROUSEL_LOOP_COPIES }, (_, copyIndex) =>
                  carouselAssets.map((item) => carouselIconItem(item, copyIndex))
                )}
              </div>
            </div>
            <div className="absolute w-full h-full bg-[linear-gradient(90deg,#fff_0%,transparent_15%,transparent_85%,#fff_100%)]" />
          </div>
        )}
      </div>
    </div>
  );
}
